import Swal from "sweetalert2";
export default {
  namespaced: true,
  state: {
    oneChartNotesInfo: null,
  },
  mutations: {
    SET_ONECHART_NOTES_INFO: (state, value) => {
      state.oneChartNotesInfo = value;
    },
  },
  actions: {
    getOneChartNotesInfo: function ({ commit }) {
      let vm = this;
      return new Promise((resolve) => {
        vm.$http.get("oneai/onechart-notes-info").then(
          (res) => {
            commit("SET_ONECHART_NOTES_INFO", res.data.data);
            resolve(res.data.data);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve();
          }
        );
      });
    },
    updateOneChartNotesInfo: function ({ commit }, payload) {
      commit("SET_ONECHART_NOTES_INFO", payload);
    },
    getEncounter: function (_, id) {
      let vm = this;
      return new Promise((resolve) => {
        vm.$http
          .get(`oneai/encounter/${id}`)
          .then((res) => {
            resolve(res?.data?.data);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
              resolve();
            }
          });
      });
    },
    createOneAiDocument: function (_, payload) {
      let vm = this;
      return new Promise((resolve) => {
        vm.$http
          .post(`oneai/encounter/${payload.id}/document`, payload)
          .then((res) => {
            resolve(res?.data?.data);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
              resolve();
            }
          });
      });
    },
    notifyAdminforOneAiUpgrade: function () {
      let vm = this;
      return new Promise((resolve) => {
        vm.$http
          .post(`oneai/notify-admin-upgrade`)
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
              resolve();
            }
          });
      });
    },
    sendOneChartConfigForApproval: function (_, payload) {
      let vm = this;
      return new Promise((resolve) => {
        vm.$http
          .post(`oneai/onechart-config-approval`, payload)
          .then((res) => {
            Swal.fire({
              title: "Success",
              text:
                res.data.message || "Your request has been sent for approval.",
              icon: "success",
            });
            resolve(true);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
              resolve();
            }
          });
      });
    },
  },
};
